import { getScrollContainer, getScrollY } from './scroll-container';

document.addEventListener("DOMContentLoaded", () => {
  const blockWrapper = document.querySelector<HTMLElement>('.ts-general-content-block-wrapper');

  if (blockWrapper) {
    const anchorLinks = blockWrapper.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');

    anchorLinks.forEach((link) => {
      link.addEventListener("click", (e: Event) => {
        e.preventDefault();

        const targetId = link.getAttribute("href")?.substring(1).trim();
        if (!targetId) return;

        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const container = getScrollContainer();
          const currentScrollPosition = getScrollY(container);
          
          if (container instanceof HTMLElement) {
            const containerTop = container.getBoundingClientRect().top;
            const targetTop = targetElement.getBoundingClientRect().top;
            const offsetPosition = container.scrollTop + (targetTop - containerTop);
            
            container.scrollTo({
              top: Math.max(offsetPosition, currentScrollPosition + 100),
              behavior: "smooth"
            });
          } else {
            const targetPosition = targetElement.getBoundingClientRect().top + currentScrollPosition;
            
            window.scrollTo({
              top: Math.max(targetPosition, currentScrollPosition + 100),
              behavior: "smooth"
            });
          }
        }
      });
    });
  }
});
